const conflictMessages = {
  OPERATOR_COUNT_SHORTAGE: 'No qualified operator is available for this treatment and time.',
  START_NOT_ALIGNED: 'The start time is not aligned with the planner interval.',
  SPA_CLOSED_DAY: 'The spa is closed on this day.',
  SPA_HOLIDAY: 'The spa is closed for a holiday.',
  OUTSIDE_OPENING_HOURS: 'The appointment is outside spa opening hours.',
  OPERATOR_BUSY: 'The selected operator is already booked.',
  OPERATOR_UNAVAILABLE: 'The selected operator is unavailable.',
  CABIN_BUSY: 'The selected cabin is already booked.',
  CABIN_BLOCKED: 'The selected cabin is blocked.',
  EQUIPMENT_BUSY: 'The selected equipment is already in use.',
  EQUIPMENT_BLOCKED: 'The selected equipment is blocked.',
  CAPACITY_EXCEEDED: 'Spa capacity is full for this time.',
};

export function formatSpaAvailabilityRejection(rejection, t) {
  if (typeof rejection === 'string') return rejection;
  if (!rejection) return '';
  const conflicts = Array.isArray(rejection.conflicts) ? rejection.conflicts : [];
  const message = conflicts.length ? conflicts.map((item) => formatSpaAvailabilityRejection(item, t)).filter(Boolean).join(', ')
    : rejection.code ? t(`spa.equipment.conflicts.${rejection.code}`, {
      defaultValue: conflictMessages[rejection.code] || rejection.message || rejection.code,
    }) : rejection.message || '';
  const resourceIds = Array.isArray(rejection.resourceIds) ? rejection.resourceIds : rejection.resourceId ? [rejection.resourceId] : [];
  const scope = String(rejection.scope || rejection.resourceType || '').toLowerCase();
  const prefix = `${scope}${resourceIds.length ? ` (${resourceIds.join(', ')})` : ''}`;
  return [prefix, message].filter(Boolean).join(': ');
}

export function sameSpaResourceCombination(first, second) {
  const canonical = (value) => {
    if (!value || !Array.isArray(value.operatorIds) || !Array.isArray(value.cabinIds) || !Array.isArray(value.equipment)) return null;
    if (value.equipment.some((item) => !item || typeof item !== 'object')) return null;
    const validIds = (ids) => ids.every((id) => Number.isInteger(id) && id > 0) && new Set(ids).size === ids.length;
    if (!validIds(value.operatorIds) || !validIds(value.cabinIds)
      || !validIds(value.equipment.map((item) => item.equipmentId))
      || value.equipment.some((item) => !Number.isInteger(item.quantity) || item.quantity <= 0)) return null;
    return JSON.stringify([
      [...value.operatorIds].sort((a, b) => a - b), [...value.cabinIds].sort((a, b) => a - b),
      value.equipment.map((item) => [item.equipmentId, item.quantity]).sort((a, b) => a[0] - b[0]),
    ]);
  };
  const key = canonical(first);
  return key !== null && key === canonical(second);
}
